import { render, staticRenderFns } from "./search-bulk-message-recipients-imports.vue?vue&type=template&id=27750aa6&"
import script from "./search-bulk-message-recipients-imports.vue?vue&type=script&lang=js&"
export * from "./search-bulk-message-recipients-imports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports